import { createSortOption } from "@nosto/preact"

export const sizes = [24, 48, 60, 72]

export const API_TOKEN = '8bfc75a336a41a5d26e545ac0b829eb8';
export const API_ENDPOINT = 'https://tnuckadmin.myshopify.com/api/2025-04/graphql.json';

export const sortOptions = [
    createSortOption("score", "Featured", { field: "score", order: "desc" }),
    createSortOption("newest", "Newest", { field: "datePublished", order: "desc" }),
    createSortOption("price", "Price (Low to High)", { field: "price", order: "asc" }),
    createSortOption("-price", "Price (High to Low)", { field: "price", order: "desc" }),
]

export const defaultConfig = {
    sort: sortOptions[0],
    serpSize: sizes[2],
    autocompleteProductsSize: 4,
    autocompleteKeywordsSize: 5,
    historySize: 5,
    currency: "USD"
}

export const productCarouselOptions = {
    slidesPerView: 1,
    slidesPerGroup: 1,
    spaceBetween: 0,
    loop: true,
    loopAddBlankSlides: true,
    navigation: false,
    preventClicks: true,
    preventClicksPropagation: true,
    watchOverflow: true,
    pagination: {
        type: 'bullets',
        el: '.swiper-pagination',
        bulletElement: 'button',
    },

    /*  Oct. 1st (added) */
    focusableElements: "input, select, option, textarea, button, video, label",
    shortSwipes: true,
    longSwipes: true,
    touchRatio: 1,
    longSwipesMs: 300,
    longSwipesRatio: 0.5,
    effect: "slide",
    followFinger: true,
    edgeSwipeDetection: false,
    loopedSlidesLimit: true,
    resistance: true,
    resistanceRatio: 0.85,
    resizeObserver: true,
    speed: 300,
    threshold: 0,
    touchAngle: 45,
    touchEventsTarget: "wrapper",
    touchMoveStopPropagation: false,
    touchRatio: 1,
    touchReleaseOnEdges: false,
    touchStartForcePreventDefault: false,
    touchStartPreventDefault: true,

    /* Oct. 1st (removed) */
    // effect: 'fade',
    // fadeEffect: {
    //     crossFade: false,
    // },
    // shortSwipes: false,
    // edgeSwipeDetection: true,

    /* options from native swiper */
    // allowSlideNext: true,
    // allowSlidePrev: true,
    // allowTouchMove: true,
    // autoHeight: false,
    // breakpoints: undefined,
    // breakpointsBase: "window",
    // centerInsufficientSlides: false,
    // centeredSlides: false,
    // centeredSlidesBounds: false,
    // containerModifierClass: "swiper-",
    // createElements: false,
    // cssMode: false,
    // direction: "horizontal",
    // edgeSwipeDetection: false,
    // edgeSwipeThreshold: 20,
    // effect: "slide",
    // enabled: true,
    // focusableElements: "input, select, option, textarea, button, video, label",
    // followFinger: true,
    // grabCursor: false,
    // height: null,
    // init: false,
    // initialSlide: 0,
    // longSwipes: true,
    // longSwipesMs: 300,
    // longSwipesRatio: 0.5,
    // loop: true,
    // loopAdditionalSlides: 0,
    // loopFillGroupWithBlank: false,
    // loopPreventsSlide: true,
    // loopedSlides: null,
    // loopedSlidesLimit: true,
    // navigation: false,
    // nested: false,
    // noSwiping: true,
    // noSwipingClass: "swiper-no-swiping",
    // noSwipingSelector: null,
    // normalizeSlideIndex: true,
    // pagination: {
    //     bulletActiveClass: "swiper-pagination-bullet-active bg-gray-800",
    //     bulletClass: "swiper-pagination-bullet h-full flex-grow block",
    //     el: ".swiper-pagination",
    //     type: "bullets",
    // },
    // passiveListeners: true,
    // preloadImages: true,
    // preventClicks: true,
    // preventClicksPropagation: true,
    // preventInteractionOnTransition: false,
    // resistance: true,
    // resistanceRatio: 0.85,
    // resizeObserver: true,
    // rewind: false,
    // roundLengths: false,
    // runCallbacksOnInit: true,
    // setWrapperSize: false,
    // shortSwipes: true,
    // simulateTouch: true,
    // slideActiveClass: "swiper-slide-active",
    // slideBlankClass: "swiper-slide-invisible-blank",
    // slideClass: "swiper-slide",
    // slideDuplicateActiveClass: "swiper-slide-duplicate-active",
    // slideDuplicateClass: "swiper-slide-duplicate",
    // slideDuplicateNextClass: "swiper-slide-duplicate-next",
    // slideDuplicatePrevClass: "swiper-slide-duplicate-prev",
    // slideNextClass: "swiper-slide-next",
    // slidePrevClass: "swiper-slide-prev",
    // slideToClickedSlide: false,
    // slideVisibleClass: "swiper-slide-visible",
    // slidesOffsetAfter: 0,
    // slidesOffsetBefore: 0,
    // slidesPerGroup: 1,
    // slidesPerGroupAuto: false,
    // slidesPerGroupSkip: 0,
    // slidesPerView: 1,
    // spaceBetween: 0,
    // speed: 300,
    // swipeHandler: null,
    // threshold: 0,
    // touchAngle: 45,
    // touchEventsTarget: "wrapper",
    // touchMoveStopPropagation: false,
    // touchRatio: 1,
    // touchReleaseOnEdges: false,
    // touchStartForcePreventDefault: false,
    // touchStartPreventDefault: true,
    // uniqueNavElements: true,
    // updateOnImagesReady: true,
    // updateOnWindowResize: true,
    // url: null,
    // userAgent: null,
    // virtualTranslate: false,
    // watchOverflow: true,
    // watchSlidesProgress: false,
    // width: null,
    // wrapperClass: "swiper-wrapper",
}

export const productSizeCarouselOptions = {
    slidesPerView: 3, 
    spaceBetween: 0,
    watchOverflow: true,
    loop: false,
    navigation: {
        prevEl: '.swiper-button-prev',
        nextEl: '.swiper-button-next',
    },
    pagination: false,
}

export const colorFacet = {
    Black: { hex: "#000000", url: null },
    White: { hex: "#FFFFFF", url: null },
    Blue: { hex: "#2B5E99", url: null },
    Tan: { hex: "#D2B48C", url: null },
    Gold: { hex: "#FFD602", url: null },
    Green: { hex: "#0E7806", url: null },
    Pink: { hex: "#E98EAE", url: null },
    Navy: { hex: "#000080", url: null },
    Brown: { hex: "#845329", url: null },
    Red: { hex: "#EA3323",url: null },
    Purple: { hex: "#7C368E", url: null },
    Yellow: { hex: "#FFFF00", url: null },
    Gray: { hex: "#808080", url: null },
    Silver: { hex: "#C0C0C0", url: null },
    Orange: { hex: "#EEA83B", url: null },
    Turquoise: { hex: "#2A999C", url: null },
    Clear: { hex: "#FFFFFF", url: null },
    Tortoise: { 
        hex: null,
        url: "https://d3kvb4j6m9vqdq.cloudfront.net/media/G0LfUZGiCGpJt1XUSUQeHBv3KzmFH1xo-3.jpg"
    },
    Multi: {
        hex: null,
        url: "https://d3kvb4j6m9vqdq.cloudfront.net/media/Jp6RSYNvlr3GrQfAjBeOtCoi1dbuTKLU-3.jpg"
    },
};

export const sizeFiltersOrder = [
    '2T', '3T', '3/4T', '4T', '5T', '6T', '7T', '8T', '9T',
    
    '0-3M', '0-6M', '1M', '2M', '3M', '3-6M', '4M', '5M', '6M', '6-9M', '6-12M', '7M', '8M', '9M', '9M', '9-12M', 
    '10M', '11M', '12M', '12-18M', '13M', '14M', '15M', '16M', '17M', '18M', '18-24M', '19M', '20M', '21M', '22M', '23M', '24M', '25M', '26M',

    '0/2Y', '0-2Y', '1/2Y', '1-2Y', '2Y', '2/3Y', '2-3Y', '3Y', '3/4Y', '3-4Y', '4Y', '4/5Y', '4-5Y', '5Y', '5/6Y', '5-6Y', 
    '6Y', '6+', '6/7Y', '6-7Y', '7Y', '7/8Y', '7-8Y', '8Y', '8/9Y', '8-9Y', '9Y', '9/10Y', '9-10Y', 
    '10Y', '10/11Y', '10-11Y', '11Y', '11/12Y', '11-12Y', '12Y', '12/13Y', '12-13Y', '13Y', '13/14Y', '13-14Y', '14Y',

    'XXS', 'XXS/XS', 
    'XS', 'XS/S', 'XS/M',
    'P', 'S', 'S/M', 'S/L', 'S/M/L', 
    'M', 'M/L', 'M/XL',
    'L', 'L/XL', 'L/XXL',
    'XL', 'XL/XXL', 
    'XXL', 'XXL/XXXL', 
    'XXXL', 'XXXL/XXXXL', 
    'XXXXL',
    'OS',

    '0', '00', '1', '1.25', '1.5', '1.75', '2', '2.25', '2.5', '2.75', '3', '3.25',
    '3.5', '3.75', '4', '4.25', '4.5', '4.75', '5', '5.25', '5.5', '5.75',
    '6', '6.25', '6.5', '6.75', '7', '7.25', '7.5', '7.75', '8', '8.25',
    '8.5', '8.75', '9', '9.25', '9.5', '9.75', '10', '10.25', '10.5', '10.75',
    '11', '11.25', '11.5', '11.75', '12', '12.25', '12.5', '12.75', '13', '13.25',
    '13.5', '13.75', '14', '14.25', '14.5', '14.75', '15', '15.25', '15.5', '15.75',
    '16', '16.25', '16.5', '16.75', '17', '17.25', '17.5', '17.75', '18', '18.25',
    '18.5', '18.75', '19', '19.25', '19.5', '19.75', '20', '20.25', '20.5', '20.75',
    '21', '21.25', '21.5', '21.75', '22', '22.25', '22.5', '22.75', '23', '23.25',
    '23.5', '23.75', '24', '24.25', '24.5', '24.75', '25', '25.25', '25.5', '25.75',
    '26', '26.25', '26.5', '26.75', '27', '27.25', '27.5', '27.75', '28', '28.25',
    '28.5', '28.75', '29', '29.25', '29.5', '29.75', '30', '30.25', '30.5', '30.75',
    '31', '31.25', '31.5', '31.75', '32', '32.25', '32.5', '32.75', '33', '33.25', '33-35',
    '33.5', '33.75', '34', '34.25', '34.5', '34.75', '35', '35.25', '35.5', '35.75', '35-38', '35-41',
    '36', '36.25', '36.5', '36.75', '36-38', '37', '37.25', '37.5', '37.75', '38', '38.25',
    '38.5', '38.75', '39', '39.25', '39.5', '39.75','39-41', '40', '40.25', '40.5', '40.75',
    '41', '41.25', '41.5', '41.75', '42', '42.25', '42.5', '42.75', '42-44', '43', '43.25',
    '43.5', '43.75', '44', '44.25', '44.5', '44.75', '45', '45.25', '45.5', '45.75',
    '46', '46.25', '46.5', '46.75', '47', '47.25', '47.5', '47.75', '48', '48.25',
    '48.5', '48.75', '49', '49.25', '49.5', '49.75', '50',

    '0 (UK 4)', '2 (UK 6)', '4 (UK 8)', '6 (UK 10)', '8 (UK 12)', '10 (UK 14)', 
    '12 (UK 16)', '14 (UK 18)', '16 (UK 20)', '18 (UK 22)', '20 (UK 24)', '22 (UK 26)',
    
    '1/2', '2/3', '3/4', '4/5', '5/6', '6/7', '7/8', '8/9', '8/10', '9/10', '10/10.5', '10/11', 
    '11/12', '12/13', '13/14', '14/15', '15/16', '16/17', '18/19', '19/20',
    '20/21', '21/22', '22/23', '23/24', '24/25', '25/26', '26/27', '27/28', '28/29', '29/30',
    '30/31', '31/32', '32/33', '33/34', '34/35', '35/36', '36/37', '37/38', '38/39', '39/40',
    '40/41', '41/42', '42/43', '43/44', '44/45', '45/46', '46/47', '47/48', '48/49', '49/50',
    
    'A', 'B', 'C', 'D', 'E',

    '4x6', '5x7', '24x36',
    
    "40mm",
    '0.53"w, 7" wrist', '.31"w, 7" wrist', '.39"w, 7"wrist',
    '7"', '7.25"', '16"', 
    '16" Chain', '18" Chain', '32" Chain',
];

export const fallbackSeachSuggestions = [
    {
        text: "Black Dress",
        url: "",
    },
    {
        text: "White Dress",
        url: "",
    },
    {
        text: "S146298",
        url: "/products/blossom-pink-tweed-jackie-dress",
    },
    {
        text: "S145068",
        url: "/products/sun-faded-floral-crawford-dress",
    },
    {
        text: "Pink Dress",
        url: "",
    },
    {
        text: "S123598",
        url: "/products/red-floral-ruffle-collar-louisa-midi-dress",
    },
]

export const fallbackSearchDesigners = [
    {
        text: "525 America",
        url: "https://tnuck.com/collections/525-america"
    },
    {
        text: "7 For All Mankind",
        url: "https://tnuck.com/collections/7-for-all-mankind"
    },
    {
        text: "A Soft Idea",
        url: "https://tnuck.com/collections/a-soft-idea"
    },
    {
        text: "A.J. Morgan Eyewear",
        url: "https://tnuck.com/collections/a-j-morgan-eyewear"
    },
    {
        text: "ADRIANA DEGREAS",
        url: "https://tnuck.com/collections/adriana-degreas"
    },
    {
        text: "AEXAE",
        url: "https://tnuck.com/collections/aexae"
    },
    {
        text: "AG Jeans",
        url: "https://tnuck.com/collections/ag-jeans"
    },
    {
        text: "AGOLDE",
        url: "https://tnuck.com/collections/agolde"
    },
    {
        text: "ALEXIS",
        url: "https://tnuck.com/collections/alexis"
    },
    {
        text: "AMA Global",
        url: "https://tnuck.com/collections/ama-global"
    },
    {
        text: "ANINE BING",
        url: "https://tnuck.com/collections/anine-bing"
    },
    {
        text: "APOF",
        url: "https://tnuck.com/collections/apof"
    },
    {
        text: "APPOINTED",
        url: "https://tnuck.com/collections/appointed"
    },
    {
        text: "ASH & EDEN",
        url: "https://tnuck.com/collections/ash-eden"
    },
    {
        text: "ASHA",
        url: "https://tnuck.com/collections/asha"
    },
    {
        text: "ASHA x Tuckernuck",
        url: "https://tnuck.com/collections/asha-x-tuckernuck"
    },
    {
        text: "ASKK NY",
        url: "https://tnuck.com/collections/askk-ny"
    },
    {
        text: "Abrams Books",
        url: "https://tnuck.com/collections/abrams-books"
    },
    {
        text: "Acrylic & Melamine",
        url: "https://tnuck.com/collections/home-acrylic-melamine"
    },
    {
        text: "Addison Bay",
        url: "https://tnuck.com/collections/addison-bay"
    },
    {
        text: "Adina Reyter",
        url: "https://tnuck.com/collections/adina-reyter"
    },
    {
        text: "Agua by Agua Bendita",
        url: "https://tnuck.com/collections/agua-by-agua-bendita"
    },
    {
        text: "Alemais",
        url: "https://tnuck.com/collections/alemais"
    },
    {
        text: "Alex Mill",
        url: "https://tnuck.com/collections/alex-mill"
    },
    {
        text: "Alexa Leigh",
        url: "https://tnuck.com/collections/alexa-leigh"
    },
    {
        text: "Alix of Bohemia",
        url: "https://tnuck.com/collections/alix-of-bohemia"
    },
    {
        text: "All Available",
        url: "https://tnuck.com/collections/all-available"
    },
    {
        text: "All Products",
        url: "https://tnuck.com/collections/all"
    },
    {
        text: "All Products BUT Private Label & Promo Exclusions",
        url: "https://tnuck.com/collections/all-products-but-private-label-promo-exclusions"
    },
    {
        text: "Amalfi Aesthetic",
        url: "https://tnuck.com/collections/amalfi-aesthetic"
    },
    {
        text: "Ame & Lulu",
        url: "https://tnuck.com/collections/ame-lulu"
    },
    {
        text: "Amicale",
        url: "https://tnuck.com/collections/amicale"
    },
    {
        text: "Ana Carolina Valencia",
        url: "https://tnuck.com/collections/ana-carolina-valencia"
    },
    {
        text: "Ancient Greek Sandals",
        url: "https://tnuck.com/collections/ancient-greek-sandals"
    },
    {
        text: "Andre Assous",
        url: "https://tnuck.com/collections/andre-assous"
    },
    {
        text: "Andree Jardin x Fer a Cheval",
        url: "https://tnuck.com/collections/andree-jardin-x-fer-a-cheval"
    },
    {
        text: "Andrée Jardin",
        url: "https://tnuck.com/collections/andree-jardin"
    },
    {
        text: "Angel Dear",
        url: "https://tnuck.com/collections/angel-dear"
    },
    {
        text: "Anina",
        url: "https://tnuck.com/collections/anina"
    },
    {
        text: "Anna Cate",
        url: "https://tnuck.com/collections/anna-cate"
    },
    {
        text: "Anniel",
        url: "https://tnuck.com/collections/anniel"
    },
    {
        text: "Antik Batik",
        url: "https://tnuck.com/collections/antik-batik"
    },
    {
        text: "Apiece Apart",
        url: "https://tnuck.com/collections/apiece-apart"
    },
    {
        text: "Apparis",
        url: "https://tnuck.com/collections/apparis"
    },
    {
        text: "Aranaz",
        url: "https://tnuck.com/collections/aranaz"
    },
    {
        text: "Ardmore Design",
        url: "https://tnuck.com/collections/ardmore-design"
    },
    {
        text: "Art",
        url: "https://tnuck.com/collections/art"
    },
    {
        text: "Artemis Design Co.",
        url: "https://tnuck.com/collections/artemis-design-co"
    },
    {
        text: "Artesano",
        url: "https://tnuck.com/collections/artesano"
    },
    {
        text: "Artifacts Trading Company",
        url: "https://tnuck.com/collections/artifacts-trading-company"
    },
    {
        text: "As Seen On",
        url: "https://tnuck.com/collections/as-seen-on"
    },
    {
        text: "Ashley McCormick",
        url: "https://tnuck.com/collections/ashley-mccormick"
    },
    {
        text: "Assouline",
        url: "https://tnuck.com/collections/assouline"
    },
    {
        text: "August Morgan",
        url: "https://tnuck.com/collections/august-morgan"
    },
    {
        text: "Aunt Megan",
        url: "https://tnuck.com/collections/aunt-megan"
    },
    {
        text: "Autumn Adeigbo",
        url: "https://tnuck.com/collections/autumn-adeigbo"
    },
    {
        text: "B Draddy",
        url: "https://tnuck.com/collections/b-draddy"
    },
    {
        text: "B-Low the Belt",
        url: "https://tnuck.com/collections/b-low-the-belt"
    },
    {
        text: "BB Dakota x Steve Madden",
        url: "https://tnuck.com/collections/bb-dakota-x-steve-madden"
    },
    {
        text: "BTB",
        url: "https://tnuck.com/collections/btb"
    },
    {
        text: "Babiators",
        url: "https://tnuck.com/collections/babiators"
    },
    {
        text: "Baby",
        url: "https://tnuck.com/collections/baby"
    },
    {
        text: "Ballen",
        url: "https://tnuck.com/collections/ballen"
    },
    {
        text: "Bandier x Lacoste",
        url: "https://tnuck.com/collections/bandier-x-lacoste"
    },
    {
        text: "Banjanan",
        url: "https://tnuck.com/collections/banjanan"
    },
    {
        text: "Barbour",
        url: "https://tnuck.com/collections/barbour"
    },
    {
        text: "Barbour x Alexa Chung",
        url: "https://tnuck.com/collections/barbour-x-alexa-chung"
    },
    {
        text: "Batsheva",
        url: "https://tnuck.com/collections/batsheva"
    },
    {
        text: "Baum und Pferdgarten",
        url: "https://tnuck.com/collections/baum-und-pferdgarten"
    },
    {
        text: "Beach Essentials",
        url: "https://tnuck.com/collections/beach-essentials"
    },
    {
        text: "Beauty",
        url: "https://tnuck.com/collections/beauty"
    },
    {
        text: "Bedding & Bath",
        url: "https://tnuck.com/collections/bedding-bath"
    },
    {
        text: "Beech Cottage Press",
        url: "https://tnuck.com/collections/beech-cottage-press"
    },
    {
        text: "Bell by Alicia Bell",
        url: "https://tnuck.com/collections/bell-by-alicia-bell"
    },
    {
        text: "Bella Cucina",
        url: "https://tnuck.com/collections/bella-cucina"
    },
    {
        text: "Belted Cow",
        url: "https://tnuck.com/collections/belted-cow"
    },
    {
        text: "Ben Amun",
        url: "https://tnuck.com/collections/ben-amun"
    },
    {
        text: "Bernardo",
        url: "https://tnuck.com/collections/bernardo"
    },
    {
        text: "Best Sellers This Week",
        url: "https://tnuck.com/collections/best-sellers-this-week"
    },
    {
        text: "Best Selling Gifts",
        url: "https://tnuck.com/collections/best-selling-gifts"
    },
    {
        text: "Beulah",
        url: "https://tnuck.com/collections/beulah"
    },
    {
        text: "Beverly Drive",
        url: "https://tnuck.com/collections/beverly-drive"
    },
    {
        text: "Bindi",
        url: "https://tnuck.com/collections/bindi"
    },
    {
        text: "Bird & Knoll",
        url: "https://tnuck.com/collections/bird-knoll"
    },
    {
        text: "Black Tie",
        url: "https://tnuck.com/collections/black-tie"
    },
    {
        text: "Blondo",
        url: "https://tnuck.com/collections/blondo"
    },
    {
        text: "Boast",
        url: "https://tnuck.com/collections/boast"
    },
    {
        text: "Boho Chic",
        url: "https://tnuck.com/collections/boho-chic"
    },
    {
        text: "Borgo De Nor",
        url: "https://tnuck.com/collections/borgo-de-nor"
    },
    {
        text: "Boys",
        url: "https://tnuck.com/collections/boys"
    },
    {
        text: "Bright This Way",
        url: "https://tnuck.com/collections/bright-this-way"
    },
    {
        text: "Brochu Walker",
        url: "https://tnuck.com/collections/brochu-walker"
    },
    {
        text: "Bunny's World",
        url: "https://tnuck.com/collections/bunnys-world"
    },
    {
        text: "CB Station",
        url: "https://tnuck.com/collections/cb-station"
    },
    {
        text: "CHUFY",
        url: "https://tnuck.com/collections/chufy"
    },
    {
        text: "CT Jewelry",
        url: "https://tnuck.com/collections/ct-jewelry"
    },
    {
        text: "Cadets",
        url: "https://tnuck.com/collections/cadets"
    },
    {
        text: "Cala de la Cruz",
        url: "https://tnuck.com/collections/cala-de-la-cruz"
    },
    {
        text: "Caliban",
        url: "https://tnuck.com/collections/caliban"
    },
    {
        text: "Canada Goose",
        url: "https://tnuck.com/collections/canada-goose"
    }
];

export const skeletonFilters = [
    "Category", 
    "Size", 
    "Type", 
    "Color", 
    "Price", 
    "Designer", 
    "Occasion", 
    "Dress Length", 
    "Sleeve Length"
]